'use strict';

var debounce = require('lodash/debounce');

const mainHeader = {
    init: function () {
        const $window = $(window);
        const $body = $('body');
        const $expHeader = $('.experience-header');
        let lastScrollTop = $window.scrollTop();

        // Updating header and shop note height in css variables
        const $header = $('.experience-commerce_assets-mainHeader');

        let $searchResults = $('.search-results').first();
        let stickyOffset = 0;

        if ($searchResults.length) {
            stickyOffset = $searchResults.offset().top;

            $(document).on('shopnoteclose', function () {
                stickyOffset = $searchResults.offset().top;
            });

            $window.on('orientationchange', function () {
                stickyOffset = $searchResults.offset().top;
            });
        }

        /**
         * Check if element is in viewport
         *
         * @param {element} el - The element to check
         * @return {boolean} - true if element is in viewport
         */
        function isInViewport(el) {
            const elementTop = $(el).offset().top;
            const elementBottom = elementTop + $(el).outerHeight();
            const viewportTop = $(window).scrollTop();
            const viewportBottom = viewportTop + window.innerHeight;

            return elementBottom > viewportTop && elementTop < viewportBottom;
        }

        // Detect scroll event
        $window.on(
            'scroll',
            debounce(function () {
                const currentScroll = $window.scrollTop();
                const headerHeight = $('.main-header-component').height() || 0;
                $expHeader.toggleClass('hide-header', $window.scrollTop() > $header.outerHeight() && !$('nav').hasClass('menu-active'));
                $('.minicart-overlay-wrapper').toggleClass('hide-header', $window.scrollTop() > $header.outerHeight());
                const isScrollDown = currentScroll > lastScrollTop;
                $body.toggleClass('scroll-up', !isScrollDown);
                lastScrollTop = currentScroll;
                if ($searchResults.length && !$body.hasClass('filter-open')) {
                    $body.toggleClass('sticky-filter-active', currentScroll >= stickyOffset - headerHeight && !$('.suggestions').length);
                }
                const $allVideos = $('.video-js');
                $allVideos.each(function () {
                    const $this = $(this);

                    if ($this.data('autoplay') && isInViewport(this)) {
                        const videojs = require('video.js').default;
                        const player = videojs.getPlayer($this[0]);

                        player.autoplay('any');
                        $this.data('autoplay', false);
                    }
                });
            }, 50)
        );

        $window.on('load orientationchange', function () {
            // Updating header and shop note height in css variables
            const $topStrip = $('.experience-commerce_assets-shopNote');
            $body.css('--header-height', $header.height() + 'px');
            $body.css('--shop-note-height', $topStrip.is(':visible') ? $topStrip.height() + 'px' : '0px');
        });
    },
};

module.exports = mainHeader;
